import { APIReferenceMember, isMathOperationMember } from '@modules/client';
import React from 'react';
import { getMemberTitle } from '../../utils/apiReferencePageNavUtils';

const ReferenceMemberTitle = ({ member }: { member: APIReferenceMember }) => {
  return isMathOperationMember(member) ? (
    <code>
      {member.typeA} {member.operation} {member.typeB}
    </code>
  ) : (
    <React.Fragment>{getMemberTitle(member.name)}</React.Fragment>
  );
};

export default ReferenceMemberTitle;
